// @ts-check

import React from "react"
import { createTaskReportsCommonCells } from "../../../../../factories/reports/createTaskReportsCommonCells.factory"
import { GroupedDateCell } from "../../../../../components/molecules/reports/GroupedDateCell.molecule"
import { BilledTimeCell } from "../../../../../components/molecules/reports/BilledTimeCell.molecule"
import { TimeDifferenceCell } from "../../../../../components/molecules/reports/TimeDifferenceCell.molecule"

/**
 * @param {import("./ClientTasksReportTable.cells.types").ClientTasksReportTableCellsParams} params
 */
export function buildClientTasksReportTableCells(params) {
  const {
    totals,
    isHoldingModifierDown,
    onLeftClickTeamMemberName,
    contextMenuRef,
    setContextMenuTarget,
    userIsAdmin,
    updatingTask,
  } = params

  const {
    DateCellTemplate,
    ProjectCodeCellTemplate,
    ModuleCellTemplate,
    CategoryCellTemplate,
    TaskCellTemplate,
    SisuTimeCellTemplate,
    SisuTimeFooterTemplate,
    BilledTimeFooterTemplate,
    TimeDifferenceFooterTemplate,
    ActionsCellTemplate,
  } = createTaskReportsCommonCells({
    totals,
    isHoldingModifierDown,
    userIsAdmin,
    updatingTask,
    contextMenuRef,
    setContextMenuTarget,
  })

  /** @param {import("./ClientTasksReportTable.controller.types").ClientTasksReportTableCellContext<string>} ctx */
  const GroupedDateCellTemplate = (ctx) => <GroupedDateCell ctx={ctx} />

  /** @param {import("./ClientTasksReportTable.controller.types").ClientTasksReportTableCellContext<string>} ctx */
  const TeamMemberCellTemplate = (ctx) => {
    const { row, getValue } = ctx
    const teamMemberNameTag = getValue()

    if (row.getIsGrouped()) {
      return null
    }

    return (
      <div
        className={`overflow-hidden white-space-nowrap text-overflow-ellipsis ${
          isHoldingModifierDown ? "ctrl-selectable" : ""
        }`}
        onClick={() => {
          if (isHoldingModifierDown) {
            onLeftClickTeamMemberName(ctx.table, teamMemberNameTag)
          }
        }}
        title={`${teamMemberNameTag} - ${row.original.teamMemberName} ${row.original.teamMemberLastName}`}
      >
        {`${teamMemberNameTag} - ${row.original.teamMemberName} ${row.original.teamMemberLastName}`}
      </div>
    )
  }

  /** @param {import("./ClientTasksReportTable.controller.types").ClientTasksReportTableCellContext<number>} ctx */
  const BilledTimeCellTemplate = (ctx) => <BilledTimeCell ctx={ctx} />

  /** @param {import("./ClientTasksReportTable.controller.types").ClientTasksReportTableCellContext<number>} ctx */
  const TimeDifferenceCellTemplate = (ctx) => <TimeDifferenceCell ctx={ctx} />

  return {
    DateCellTemplate,
    GroupedDateCellTemplate,
    ProjectCodeCellTemplate,
    TeamMemberCellTemplate,
    ModuleCellTemplate,
    CategoryCellTemplate,
    TaskCellTemplate,
    SisuTimeCellTemplate,
    SisuTimeFooterTemplate,
    BilledTimeCellTemplate,
    BilledTimeFooterTemplate,
    TimeDifferenceCellTemplate,
    TimeDifferenceFooterTemplate,
    ActionsCellTemplate,
  }
}
